import React, { useState, useEffect } from "react";
import { Col, Row, Image } from "react-bootstrap";
import { getSupportedCodeFixes } from "typescript";
import Phone from "../../../assets/images/phone.png";
import Mail from "../../../assets/images/mail.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Home.css";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  GetCodeOfConductData,
  selectcodeOfConductData,
} from "../../../features/home/codeOfConductSlice";
import parse from "html-react-parser";
const support = {
  email: "ethics@mahindra.com",
  tollFree: "000 800 100 4175 (toll free)",
};

const ReportCodeOfConductViolations = ({
  GetcodeOfConductData,
}: {
  GetcodeOfConductData: any;
}) => {
  // const codeOfConductData = useAppSelector(selectcodeOfConductData);
  // const dispatch = useAppDispatch();
  // const userDetails=localStorage.getItem("userDetails");
  // const userDetailsList:any=userDetails
  // const userDetailsJson=JSON.parse(userDetailsList)
  useEffect(() => {
    // async function fetchcodeOfConductData() {
    //   let sample = await dispatch(GetCodeOfConductData(userDetailsJson));
    // }
    // fetchcodeOfConductData();
  }, []);
  const ethicksHelpline = () => {
    // route to new page by changing window.location
    window.open(GetcodeOfConductData?.url, "_blank"); //to open new page
  };
  // const[tollfree, setTollfree]=useState(codeOfConductData.tollFree)
  // const[email, setEmail]=useState(codeOfConductData.email)
  return (
    <>
      <Row xs={12} className="m-0 p-0">
        <h4 style={styles.heading} className="lrpad-mob0-desk12">
          Report code of conduct violations
        </h4>
        <br />
        <div style={styles.subHeading} className="lrpad-mob0-desk12">
          Report an incident or track its status
        </div>
        <br />
        <br />
        <div style={styles.details} className="lrpad-mob0-desk12">
          Report an incident about workplace issues like financial and auditing
          concerns, harassment, theft, substance, abuse, unsafe conditions and
          any other code of conduct violations.
          <br />
          <br />
          Click the link below to report any violations and track your complaint
          of an ongoing incident.
        </div>
      </Row>
      <Row>
        {/* <Col sm={8} xs={12}>
          <Row style={{ marginBottom: "20px", marginTop: "20px" }} className="mx-0 px-0">

            <Col sm={12} className="lrpad-mob0-desk12">
              <img src={Phone} />
              {GetcodeOfConductData?.tollFree ? parse("" + GetcodeOfConductData?.tollFree) : "000 800 100 4175"} (toll free)
            </Col>
          </Row >
          <hr />

          <Row>
            <Col sm={12} className="lrpad-mob0-desk12" style={{ paddingLeft: "25px" }}>
              <img src={Mail} />
              {GetcodeOfConductData?.email ? parse("" + GetcodeOfConductData?.email) : "ethics@mahindra.com"}
            </Col>
          </Row>
        </Col> */}

        <Col sm="auto" xs={12} className="lrpad-mob0-desk12 mt-5 ms-2">
          <button
            className="button mx-0"
            onClick={ethicksHelpline}
            style={styles.mob_button}
          >
            ETHICS HELPLINE
          </button>
        </Col>
      </Row>
    </>
  );
};

const styles: any = {
  heading: {
    // fontFamily: "QuantumRiseGX",
    fontFamily: "Georama-Regular",
    fontSize: "14px",
    fontWeight: "bold",
    fontStrech: "normal",
  },

  subHeading: {
    fontSize: "14px",
    fontWeight: "medium",
  },
  details: {
    fontSize: "14px",
    fontWeight: "normal",
    lineHeight: 1.5,
  },
  helpline: {
    fontFamily: "Georama-Regular",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "normal",
    fontStretch: "normal",
    paddingLeft: "15px",
    paddingRight: "15px",
    textAlign: "left",
  },
  button: {
    padding: "14px 14px",
    fontFamily: "Georama-Regular",
    fontSize: "12px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
  },

  mob_button: {
    padding: "10px 30px",
    fontFamily: "Georama-Regular",
    // width: "105px",
    fontSize: "14px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
  },

  bottomLine: {
    height: "1px",
    backgroundColor: "#e3e3e3",
    margin: "10px 0px",
    width: "45%",
  },
};

export default ReportCodeOfConductViolations;
